<template>
  <SatisfactionComp :type="type" :qrcode="qrcode" />
</template>

<script>
import { satisfactionQrcodeUrl } from "./data/satisfaction";
import SatisfactionComp from "./layouts/SatisfactionComp.vue";

export default {
  name: "Satisfaction",
  components: { SatisfactionComp },
  data() {
    return {
      type: 1,
      qrcode: satisfactionQrcodeUrl,
    };
  },
};
</script>

<style lang="less" scoped></style>
